import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import type { Connection, Provider } from "../../../../api/client.ts";
import CrmProviderLogo from "../../../../components/CrmProviderLogo.tsx";

interface UpdateCredentialsDialogProps {
  connection: Connection | null;
  providers: Provider[] | undefined;
  newCredentials: Record<string, string>;
  onCredentialChange: (name: string, value: string) => void;
  onSave: () => void;
  onClose: () => void;
  saving: boolean;
}

export default function UpdateCredentialsDialog({
  connection,
  providers,
  newCredentials,
  onCredentialChange,
  onSave,
  onClose,
  saving,
}: UpdateCredentialsDialogProps) {
  const provider = providers?.find((p) => p.id === connection?.provider);
  return (
    <Dialog open={!!connection} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
          {connection && <CrmProviderLogo provider={connection.provider} />}
          <span>Update credentials — {connection?.name || provider?.name || connection?.provider}</span>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {provider?.credential_fields.map((field) => (
            <TextField
              key={field.name}
              label={field.label}
              type={field.field_type}
              size="small"
              required={field.required}
              helperText={field.help_text || undefined}
              autoComplete="off"
              value={newCredentials[field.name] ?? ""}
              onChange={(e) => onCredentialChange(field.name, e.target.value)}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={saving} onClick={onSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
